<script setup lang="ts">
import SvgIcon from '@/shared/components/icon/SvgIcon.vue'

interface Props {
  title?: string
  text?: string
  icon?: string
}

defineOptions({ inheritAttrs: false })
defineProps<Props>()
</script>

<template>
  <button
    type="button"
    class="group inline-flex items-center cursor-pointer border border-gray-500 enabled:text-black dark:border-gray-800 dark:enabled::text-gray-300 dark:enabled:hover:bg-gray-800 enabled:hover:bg-gray-100 p-2 disabled:border-dashed disabled:border-gray-400 disabled:text-gray-400"
    :title="title || text"
    v-bind="$attrs"
  >
    <SvgIcon
      :path="icon"
      class="fill-gray-700 dark:fill-white h-5 w-5 group-disabled:fill-gray-400"
    />
    <span v-if="text" class="ms-1.5 me-2 text-sm text-nowrap">{{ text }}</span>
  </button>
</template>
